import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Store } from '@ngrx/store'
import { takeUntil } from 'rxjs/operators'
import { VendorConversationTeamV1 } from '../../api/api/models/vendor-conversation-team-v1'

import { AppState } from '../../store'
import { CommonComponent } from '../common.component'
import * as Menu from './menu/store/actions/menu.actions'
import * as App from '../../store/actions/app.actions'
import * as Auth from '../auth/store'
import * as fromAuth from './../auth/store'
import * as fromTeam from '../team/store'

import { MY_WORK_ID } from '../team/store/reducers/conversation-team.reducer'
import { MenuRoutes } from './menu/menu-actions'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent extends CommonComponent {

  title = 'Expert'
  teams: VendorConversationTeamV1[]
  user$ = this.rootStore.select(fromAuth.getAuthUser)
  teams$ = this.rootStore.select(fromTeam.getConversationTeamsSelector)
  teamSelectedId$ = this.rootStore.select(fromTeam.getSwitchedTeamIdSelector)

  constructor(private rootStore: Store<AppState>,
              private route: ActivatedRoute) {
    super()

    this.teams$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(teams => this.teams = teams)
  }

  goHome() {
    this.rootStore.dispatch(new App.Go({path: ['/']}))
  }

  onTeamSelected(team: VendorConversationTeamV1) {
    let path = ['/chat/team', team.id]
    if (+team.id === MY_WORK_ID) {
      path = ['/chat']
    }
    this.rootStore.dispatch(new App.Go({path}))
  }

  menuItemSelected(route: string) {
    if (route === MenuRoutes.logout) {
      this.rootStore.dispatch(new Auth.LogoutApi())
    } else {
      this.rootStore.dispatch(new Menu.SelectMenuItem(route))
    }

  }

  isOnChat() {
    return this.route.snapshot.firstChild
      ? this.route.snapshot.firstChild.data.module === 'chat'
      : false
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts